import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached follows data
export function useCountriesSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/supported_countries"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
